import "./projectPage.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import WhiteHeader from "../components/whiteHeader";
import m1 from "../assets/photos/mezarlık_kompleksi/1.jpeg"
import m2 from "../assets/photos/mezarlık_kompleksi/2.jpeg"
import m3 from "../assets/photos/mezarlık_kompleksi/3.jpeg"
import a1 from "../assets/photos/yeni1.jpeg"
import a2 from "../assets/photos/yeni2.jpeg"
import a3 from "../assets/photos/yeni3.jpeg"
import a4 from "../assets/photos/yeni21.jpeg"
import a5 from "../assets/photos/yeni22.jpeg"
import a6 from "../assets/photos/yeni23.jpeg"
import a7 from "../assets/photos/yeni24.jpeg"



export const projects = {
    "mezarlik-kompleksi-yozgat-sorgun": {
        title: "Mezarlık Kompleksi Yozgat Sorgun",
        description: "Mezarlık Kompleksi (Camii, Gasilhane, Taziye evi ve Mezarlık Yerleri) Yapım İşi",
        images: [m1, m2, m3]
    },
    "malatya-toki-projesi": {
        title: "Malatya 404 Konut Toki Projesi",
        description: "Malatya İli, Yeşilyurt İlçesi, Merkez 19. Bölge 404 Adet Konut, 114 Adet Dükkan ve 12 Adet Ofis İnşaatları İnce İmalatlar Yapım İşi",
        images: [a1, a2, a3, a4, a5, a6, a7]
    }
};

const ProjectPage = () => {
    const navigate = useNavigate();

    const { slug } = useParams();
    const project = projects[slug];
    const [selectedImage, setSelectedImage] = useState(null);

    if (!project) return <div style={{ color: "white", padding: "120px 2rem" }}>Proje bulunamadı.</div>;

    return (
        <div style={{ minHeight: "100vh", background: "#0f2f2f", color: "white" }}>
            <WhiteHeader scrollTargetRef={[]} />
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "120px 2rem 2rem" }}>
                <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{project.title}</h1>
                <p style={{ opacity: 0.75, lineHeight: 1.7, marginBottom: "3rem" }}>{project.description}</p>

                <div className="images-grid">
                    {project.images.map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt={`${project.title} - ${i + 1}`}
                            className="project-image"
                            onClick={() => setSelectedImage(src)}
                        />
                    ))}
                </div>
            </div>
            <button
                onClick={() => navigate(-1)}
                style={{
                    marginTop: "32px",
                    padding: "10px 24px",
                    backgroundColor: "#1a7373",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "1rem"
                }}
            >
                Geri Dön
            </button>
            {selectedImage && (
                <div className="lightbox" onClick={() => setSelectedImage(null)}>
                    <img src={selectedImage} alt="büyük görsel" className="lightbox-image" />
                </div>
            )}
        </div>
    );
};

export default ProjectPage;